import { useAppDispatch, useAppSelector } from '../../../../../store';
import { lightboxSliceActions } from '../../model/lightboxSlice';
import { ILightboxSchema, IPreviewFile } from '../../model/types';

export const useLightBoxControl = () => {
    const { files, currentFileId, currentFile } = useAppSelector(
        (state) => state.lightboxSliceReducer
    );
    const dispatch = useAppDispatch();
    const { onShow, onClose } = lightboxSliceActions;

    const onShowLightBox = ({
        id,
        newFiles,
    }: {
        id: ILightboxSchema['currentFileId'];
        newFiles: IPreviewFile[];
    }) => {
        dispatch(onShow({ currentFileId: id, files: newFiles }));
    };
    const onCloseLightBox = () => {
        dispatch(onClose());
    };

    return { currentFileId, onShowLightBox, onCloseLightBox, files, currentFile };
};
